import axios from 'axios';

const baseURL = '/api/organizations';
const shareProfileURL = '/share_profiles';

/**
 * Posts the share campaign (share profile)
 * @param oppID the opportunity id
 * @param opportunityReply the reply we are using
 */
export const postShareCampaign = (shareCampaignData, orgID) => {
	shareCampaignData['organization_id'] = orgID;
	return axios
		.post(`${baseURL}/${orgID}${shareProfileURL}`, shareCampaignData)
		.then((response) => {})
		.catch((error) => {
			console.error(error);
		});
};
